export const MIME_TYPE_VIDEOS = ['video/mp4', 'video/quicktime', 'video/webm'];
